import { useState } from "react";
import {
  Button,
  TextField,
  Box,
  Paper,
  CircularProgress,
} from "@material-ui/core";

export const VtrSearchBar: React.FC<{
  onFetch: (vtrId: string) => void;
  loading: boolean;
}> = ({ onFetch, loading }) => {
  const [vtrId, setVtrId] = useState("");

  const handleSearch = () => {
    const trimmedVtrId = vtrId.trim();

    if (trimmedVtrId && !loading) {
      onFetch(trimmedVtrId);
    }
  };

  return (
    <Paper
      elevation={3}
      style={{
        padding: 16,
        borderRadius: 12,
        marginBottom: 24,
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        style={{gap:16}}
      >
        <TextField
          label="VTR ID"
          placeholder="Enter Company Vtr Id"
          variant="outlined"
          value={vtrId}
          onChange={(e) => setVtrId(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleSearch();
            }
          }}
          fullWidth
          disabled={loading}
        />

        <Button
          variant="contained"
          color="primary"
          onClick={handleSearch}
          disabled={!vtrId.trim() || loading}
          style={{
            minHeight: 56,
            padding: "0 24px",
            whiteSpace: "nowrap",
            fontWeight: 600,
          }}
        >
          {loading ? (
            <CircularProgress size={22} color="inherit" />
          ) : (
            "Fetch Reputation"
          )}
        </Button>
      </Box>
    </Paper>
  );
};
